export default {
  LABOUR: 'LAB',
  PARTS: 'PRT',
  OPG: 'OPG',
  MISC: 'MISC',
  SUBL: 'SUBL'
}
